export default __webpack_public_path__ + "static/media/TIME.69960a4b.png";